"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultStyling = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _ReadinessCheckerMessaging = require("../ReadinessCheckerMessaging.styled");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = require("prop-types");
var DefaultStyling = exports.DefaultStyling = function DefaultStyling(_ref) {
  var title = _ref.title,
    content = _ref.content,
    learnMoreLink = _ref.learnMoreLink;
  return _react["default"].createElement(_ReadinessCheckerMessaging.StyledMessagingWrapper, null, _react["default"].createElement(_reactstrap.Row, null, _react["default"].createElement(_reactstrap.Col, {
    md: 5
  }, "\u2022 \xA0 ", title), _react["default"].createElement(_reactstrap.Col, {
    md: 7
  }, content, learnMoreLink && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ReadinessCheckerMessaging.StyledLinkText, {
    href: learnMoreLink,
    target: "_blank",
    "data-testid": "learn-more-link"
  }, "Learn more"), _react["default"].createElement("a", {
    href: learnMoreLink,
    target: "_blank",
    rel: "noreferrer"
  }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "text-primary",
    icon: _freeSolidSvgIcons.faUpRightFromSquare
  }))))));
};
DefaultStyling.propTypes = {
  title: _propTypes.string,
  content: _propTypes.string,
  learnMoreLink: _propTypes.string
};